<template>
  <div class="flex-wrap flex-between l-status-bar">
    <slot></slot>

  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
  .l-status-bar{
    height:30px;
    background:var(--bg2);
    color:var(--text2);
    border-bottom:1px solid var(--border);

    border-top:1px solid var(--border);
    padding:0 10px;
    position: absolute;
    bottom:0;
    left:0;
    right:0;
  }

  .l-status-bar-dark{
    background:var(--bg1);
    color:var(--text1);
  }

</style>
